import { useTranslation } from "react-i18next";

import { AuthCard, ResetPasswordForm } from "@/components/auth";

export function ResetPasswordPage() {
  const { t } = useTranslation("auth");

  return (
    <AuthCard title={t("resetPassword.title")} description={t("resetPassword.subtitle")}>
      <ResetPasswordForm />
    </AuthCard>
  );
}

export default ResetPasswordPage;
